import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getCache, getAllCache, getItemFromArrayByKey } from '@/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Index.vue')
  },
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main/Index.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/Index.vue'),
        meta: {
          // keepAlive: true
        }
      },
      // 组织机构管理
      {
        path: '/userDept',
        name: 'userDept',
        component: () => import('../views/jcxx/userDept/Index.vue'),
        meta: {
          //keepAlive: true
        }
      },
      //行政区域
      {
        path: '/adminDivision',
        name: 'adminDivision',
        component: () => import('../views/jcxx/adminDivision/Index.vue'),
        meta: {
          //keepAlive: true
        }
      },
      // 系统配置
      {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import('../views/xtpz/userCenter.vue'),
        meta: {
          // keepAlive: true
        }
      },
      {
        path: '/peopleManagement',
        name: 'peopleManagement',
        component: () => import('../views/xtpz/yhgl/peopleManagement.vue'),
        meta: {
          // keepAlive: true
        }
      },
      {
        path: '/roleManagement',
        name: 'roleManagement',
        component: () => import('../views/xtpz/roleManagement.vue'),
        meta: {
          // keepAlive: true
        }
      },
      {
        path: '/menuManagement',
        name: 'menuManagement',
        component: () => import('../views/xtpz/menuManagement.vue'),
        meta: {
          // keepAlive: true
        }
      },
      {
        path: '/logManagement',
        name: 'logManagement',
        component: () => import('../views/xtpz/logManagement.vue'),
        meta: {
          // keepAlive: true
        }
      },
      {
        path: '/functionparams',
        name: 'functionparams',
        component: () => import('../views/tysz/functionParams'),
        meta: {
          // keepAlive: true
        }
      },
      //培训视频播放页面
      {
        path: '/trainingVideo',
        name: 'trainingVideo',
        component: () => import('../views/trainingVideo/xiaoyuanshaobing/Index.vue'),
        meta: {
          keepAlive: false
        }
      },
      //测试页面
      {
        path: '/testpage',
        name: 'testpage',
        component: () => import('../views/testpage/test'),
        meta: {
          // keepAlive: true
        }
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (store.state.token || to.path == '/login') {
    gotoPage(to, from, next)
  } else {
    if (getCache('token')) {
      let cacheDatas = getAllCache();
      store.commit('setCacheDatas', cacheDatas);
      // gotoPage(to, from, next);
      // 刷新页面回到首页
      next('/')
    } else {
      next("/login");
    }
  }
})

const gotoPage = (to, from, next) => {
  // 回到页面顶部
  try {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  } catch (e) {
    document.body.scrollTop = 0;
  }
  // 路由参数缓存
  let params = to.params;
  if (params) {
    if (Object.keys(params).length) {
      store.commit('setPageParams', {
        path: to.path,
        params: params
      });
    } else if (store.state.paramsMap[to.path]) {
      params = store.state.paramsMap[to.path];
      for (let key in params) {
        to.params[key] = params[key];
      }
    }
  }
  next();
}

router.afterEach((to, from) => {
  // 当前菜单选中状态
  store.commit('main/setSelectedKeys', [to.name])
  // 顶部tab页
  if (to.path) {
    store.dispatch('main/addTab', to.name)
  }
  store.commit('main/setSelectedTab', to.name)
})

export default router
